import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2e42794"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full negative-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Citas", -1))
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body pt-0 px-0" }
const _hoisted_6 = { class: "row mt-5 mb-5" }
const _hoisted_7 = { class: "col-xs-12 col-sm-9 col-md-9 col-lg-9" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mb-2" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_11 = { class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mb-2" }
const _hoisted_12 = { class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mb-2" }
const _hoisted_13 = { class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mb-2" }
const _hoisted_14 = { class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mb-2" }
const _hoisted_15 = { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 text-end mb-2" }
const _hoisted_16 = { class: "svg-icon svg-icon-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Descargar"),
  /*#__PURE__*/_createElementVNode("span", null, " listado")
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_20 = {
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_21 = {
  src: "media/icons/iconsax/red_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "row"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sin resultados")
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "row align-items-center py-3 px-3 m-0 border border-top-0 border-gray-600 rounded-bottom bg-gray footer-position-table"
}
const _hoisted_27 = { class: "col-sm-12 col-md-6 mb-3 mb-md-0 d-flex flex-row align-items-center fs-sm" }
const _hoisted_28 = { class: "me-2" }
const _hoisted_29 = { class: "col-sm-12 col-md-6 text-end" }
const _hoisted_30 = {
  id: "kt_referre_dusers_tab_content_pagination",
  class: "tab-content"
}
const _hoisted_31 = { class: "pagination justify-content-end fs-xs" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "page-link"
}
const _hoisted_34 = {
  class: "modal fade",
  id: "citaDetailModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "citaDetailModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_36 = { class: "modal-content rounded" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pt-6 pb-3 px-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-2 fw-bold mb-3 text-left" }, "Detalle de la cita"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-sm btn-icon",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" })
    ])
  ])
], -1))
const _hoisted_38 = { class: "modal-body px-15 pt-0" }
const _hoisted_39 = { class: "row mt-5" }
const _hoisted_40 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-2 mb-5" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Tipo de cita", -1))
const _hoisted_42 = {
  key: 0,
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_43 = {
  key: 1,
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_44 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Estatus", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}, null, -1))
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}, null, -1))
const _hoisted_50 = { key: 2 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/iconsax/red_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}, null, -1))
const _hoisted_52 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Día", -1))
const _hoisted_54 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Horario", -1))
const _hoisted_56 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Agencia", -1))
const _hoisted_58 = { class: "mb-2" }
const _hoisted_59 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Cliente", -1))
const _hoisted_61 = { class: "mb-2" }
const _hoisted_62 = { class: "ms-11 mb-2" }
const _hoisted_63 = { class: "ms-11" }
const _hoisted_64 = {
  key: 0,
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Vehículo de interés", -1))
const _hoisted_66 = { class: "mb-2" }
const _hoisted_67 = {
  key: 1,
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Vehículo", -1))
const _hoisted_69 = { class: "mb-2" }
const _hoisted_70 = { class: "ms-11 mb-2" }
const _hoisted_71 = { class: "ms-11" }
const _hoisted_72 = {
  key: 2,
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Precio cotizado", -1))
const _hoisted_74 = { class: "mb-2" }
const _hoisted_75 = {
  key: 3,
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Valuador", -1))
const _hoisted_77 = { class: "mb-2" }
const _hoisted_78 = {
  key: 4,
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 d-grid mt-5 mb-5"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base mb-2" }, "Vehículo a tomar a cuenta", -1))
const _hoisted_80 = { class: "mb-2" }
const _hoisted_81 = { class: "ms-11 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.total == 1 ? " Registro" : " Registros"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/duotune/general/gen021.svg",
                    class: "lineH"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "data-kt-subscription-table-filter": "search",
                  class: "form-control form-control-solid fs-base ps-14 inputSearch me-0",
                  placeholder: "Buscar",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buscar) = $event)),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchDebouncer && _ctx.searchDebouncer(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.buscar]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Field, {
                  "data-kt-subscription-table-filter": "search",
                  name: "Valuador",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible",
                  modelValue: _ctx.valuador,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valuador) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "Valuador",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.setValuador
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Valuador",
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Valuador")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valuadores, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name + ' ' + item.last_name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Field, {
                  "data-kt-subscription-table-filter": "search",
                  name: "Tipo",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible",
                  modelValue: _ctx.tipo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipo) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "Tipo",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.setTipo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Field, {
                  "data-kt-subscription-table-filter": "search",
                  name: "Estatus",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible",
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "Estatus",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.setStatus
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Field, {
                  "data-kt-subscription-table-filter": "search",
                  name: "Agencia",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible",
                  modelValue: _ctx.agencia,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agencia) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "Agencia",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.setAgencia
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Agencia",
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Agencia")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencies, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary fs-base btn-responsive btn-download",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searching(true)))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/directbox-receive.svg" })
              ]),
              _hoisted_17
            ])
          ])
        ]),
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData1,
          loading: _ctx.loading,
          "table-header": _ctx.headerConfig,
          "enable-items-per-page-dropdown": false,
          rowsPerPage: parseInt(_ctx.showing)
        }, {
          "cell-prospecto": _withCtx(({ row: customer }) => [
            _createElementVNode("span", {
              class: "text-gray-800 text-hover-primary cursorPointer mb-1",
              onClick: ($event: any) => (_ctx.openModal(customer.id))
            }, _toDisplayString(customer.prospecto), 9, _hoisted_18)
          ]),
          "cell-agencia": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.agencia), 1)
          ]),
          "cell-tipo": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.tipo), 1)
          ]),
          "cell-fecha": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.fecha), 1)
          ]),
          "cell-vehiculo": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.vehiculo), 1)
          ]),
          "cell-estatus": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                [_vShow, customer.estatus === 'Atendida']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                [_vShow, customer.estatus === 'Pendiente']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                [_vShow, customer.estatus === 'Cancelada']
              ]),
              _createTextVNode(" " + _toDisplayString(customer.estatus), 1)
            ])
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["table-data", "loading", "table-header", "rowsPerPage"]),
        (_ctx.noResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (_ctx.total > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("span", _hoisted_28, "Elementos por página:", 512), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createVNode(_component_Field, {
                  name: "pages",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible w-75p pageNumber",
                  modelValue: _ctx.showing,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showing) = $event))
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      name: "pages",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      class: _normalizeClass([_ctx.pageNumber, "w-75px"]),
                      onChange: _ctx.showingSet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 10,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("10")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 25,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("25")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 50,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("50")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 100,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("100")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "class", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createElementVNode("span", { class: "w-25 fs-sm" }, " " + _toDisplayString(_ctx.from) + " - " + _toDisplayString(_ctx.to) + " de " + _toDisplayString(_ctx.total), 513), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("ul", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (lin, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass([
                  lin ? 'page-item' : '',
                  lin.active ? 'active' : '',
                  lin.url == null ? 'disabled' : '',
                ]),
                        onClick: ($event: any) => (_ctx.getPagination(lin))
                      }, [
                        (lin.url != null)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_33, _toDisplayString(lin.label.includes("Anterior")
                      ? "<"
                      : lin.label.includes("Siguiente")
                      ? ">"
                      : lin.label), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_32))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("span", null, [
                  (_ctx.dtipo == 'Venta')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                    : (_openBlock(), _createElementBlock("img", _hoisted_43)),
                  _createTextVNode(" " + _toDisplayString(_ctx.dtipo), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                (_ctx.dstatus == 'Pendiente')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                      _hoisted_47,
                      _createTextVNode(" " + _toDisplayString(_ctx.dstatus), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dstatus == 'Atendida')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                      _hoisted_49,
                      _createTextVNode(" " + _toDisplayString(_ctx.dstatus), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dstatus == 'Cancelada')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      _hoisted_51,
                      _createTextVNode(" " + _toDisplayString(_ctx.dstatus), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("span", null, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/calendar.svg",
                    style: {"margin-right":"7px"}
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.ddia), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("span", null, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/clock-1.svg",
                    style: {"margin-right":"7px"}
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.dhorario), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("span", _hoisted_58, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/shop.svg",
                    style: {"margin-right":"7px"}
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.dagencia), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: {name:'agencies-detail', params: {id:_ctx.didagencia}},
                  class: "ms-9 links"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver detalles ")
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("span", _hoisted_61, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/user.svg",
                    style: {"margin-right":"7px"}
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.dcliente), 1)
                ]),
                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.dmail), 1),
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.dphone), 1)
              ]),
              (_ctx.dtipo == 'Venta')
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/iconsax/car.svg",
                        style: {"margin-right":"7px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.dvehiculo), 1)
                    ]),
                    _createVNode(_component_router_link, {
                      to: {name:'vehicles-detail', params: {id:_ctx.didvehicle}},
                      class: "ms-9 links"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Ver detalle ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dtipo != 'Venta')
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("span", _hoisted_69, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/iconsax/car.svg",
                        style: {"margin-right":"7px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.dvehiculo), 1)
                    ]),
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.dkms) + " KM ", 1),
                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.dduenios) + " dueños ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dtipo != 'Venta')
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("span", _hoisted_74, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/iconsax/card.svg",
                        style: {"margin-right":"7px"}
                      }),
                      _createTextVNode(" $" + _toDisplayString(_ctx.dprecio), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dtipo != 'Venta')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _hoisted_76,
                    _createElementVNode("span", _hoisted_77, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/iconsax/medal.svg",
                        style: {"margin-right":"7px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.dvaluador), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dvehiclecuenta != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("span", _hoisted_80, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/iconsax/dollar-circle.svg",
                        style: {"margin-right":"7px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.dvehiclecuenta), 1)
                    ]),
                    _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.dvehiclekmscuenta) + " KM ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}